import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { HelpCircle } from "lucide-react";

const faqs = [
  {
    question: "Posso usar comercialmente?",
    answer: "Sim! A marca é 100% sua. Você tem direitos totais para usar em fachada, Instagram, notas fiscais e registro de empresa."
  },
  {
    question: "Quanto tempo demora?",
    answer: "São 6 cliques. Menos de 3 minutos. A inteligência artificial gera as opções instantaneamente e você edita em tempo real."
  },
  {
    question: "E se eu não gostar do resultado?",
    answer: "Você tem total controle. Pode gerar até 10 variações de logos (9 revisões) e retornar às etapas anteriores para ajustar cores e ícones quantas vezes precisar. Só paga quando estiver satisfeito."
  },
  {
    question: "Os arquivos são em alta qualidade?",
    answer: "Sim! Você recebe arquivos PNG em alta definição, com e sem fundo transparente. Perfeitos para impressão em fachadas, banners, cartões de visita e uso digital no Instagram e WhatsApp."
  },
  {
    question: "Preciso de conhecimento em design?",
    answer: "Não! A ferramenta foi criada para empreendedores sem experiência em design. Você só precisa responder algumas perguntas simples e a inteligência artificial faz o resto."
  },
  {
    question: "Posso cancelar ou pedir reembolso?",
    answer: "Como você só paga após aprovar o resultado, não há necessidade de reembolso. Você visualiza tudo antes de finalizar a compra. Qualquer dúvida, nosso suporte está disponível pelo WhatsApp."
  }
];

export const FAQ = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-background overflow-hidden">
      <div className="container mx-auto px-5 sm:px-6">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-8 sm:mb-10 lg:mb-12">
            <div className="inline-flex items-center gap-2 bg-primary/10 text-primary px-4 py-2 rounded-full mb-6">
              <HelpCircle className="h-4 w-4" />
              <span className="text-sm font-medium">Perguntas Frequentes</span>
            </div>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-display font-bold text-foreground mb-3 leading-tight tracking-tight text-balance">
              Tire suas dúvidas
            </h2>
            <p className="text-muted-foreground text-base sm:text-lg leading-relaxed">
              Respondemos as perguntas mais comuns sobre o ClickLogos
            </p>
          </div>

          {/* FAQ Accordion */}
          <Accordion type="single" collapsible className="space-y-3 sm:space-y-4">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-secondary/30 border border-border/50 rounded-xl px-4 sm:px-6 data-[state=open]:bg-secondary/50 !border-b-border/50"
              >
                <AccordionTrigger className="text-left text-foreground font-semibold hover:no-underline py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground pb-5 leading-relaxed">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>

          {/* CTA */}
          <div className="text-center mt-12">
            <p className="text-muted-foreground mb-2">
              Ainda tem dúvidas?
            </p>
            <a 
              href="mailto:suporteclicklogos@gmail.com" 
              className="text-primary font-medium hover:underline"
            >
              Entre em contato conosco
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
